import { ContentBlock, ContentState } from 'draft-js';

export default function findLinkEntities(contentBlock: ContentBlock, callback, contentState: ContentState) {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        // TODO: try changing type to "LINK_WORD"
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
}
